import '@styles/index.scss'
import '@translations/i18n'
import initWidgets from '@app/widgets/initWidgets'

initWidgets()
